import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Heading, Paragraph } from 'components/Typography';
import { ScreenerResultsCtx } from 'domains/signup/screener/Components/ScreenerResultsSummary/context';

import { Button } from 'components/Button';

export const ScreenerResultsScheduleSection: React.FC = () => {
  const {
    onProceedToSchedule,
    results: { targetPatient },
  } = useContext(ScreenerResultsCtx);
  const { t } = useTranslation();

  return (
    <section>
      <Heading level="h5" useDefaultMargins>
        {t('screener.results.schedule.title')}
      </Heading>
      <Paragraph useDefaultMargins>{t('screener.results.schedule.explanation')}</Paragraph>
      <Paragraph useDefaultMargins>{t(`screener.results.schedule.explanation.${targetPatient}`)}</Paragraph>

      <div className="grid grid-cols-2 sm-d:grid-cols-1 gap-16">
        <Button size="lg" onClick={onProceedToSchedule}>
          {t('screener.results.schedule.button')}
        </Button>

        <Button as="a" size="lg" variant="ghost" className="min-w-[max-content]" href="#answers">
          {t('screener.results.schedule.learnMore')}
        </Button>
      </div>
    </section>
  );
};
